import { render } from "./ProductsGallery.vue?vue&type=template&id=763370a8"
import script from "./ProductsGallery.vue?vue&type=script&lang=js"
export * from "./ProductsGallery.vue?vue&type=script&lang=js"

import "./ProductsGallery.vue?vue&type=style&index=0&id=763370a8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__